import { StateCreator } from 'zustand';

import {
  handleGetDropdownSelectedItems,
  handleGetIsFromDoBoxPreview,
  handleResetDropdownStates,
  handleRestoreDropdownStates,
  handleRestoreDropdownStatesEnhanced,
  handleSaveDropdownSelectedItems,
  handleSaveDropdownStates,
  handleSaveDropdownStatesEnhanced,
  handleSetFromDoBoxPreview,
} from './handlers';
import { DoBoxDropdownStore, INITIAL_DOBOX_DROPDOWN_STATE } from './types';

export const createDoBoxDropdownSlice: StateCreator<DoBoxDropdownStore> = (
  set,
  get,
) => {
  return {
    ...INITIAL_DOBOX_DROPDOWN_STATE,
    saveDropdownStates: (dropdownStates) =>
      handleSaveDropdownStates(set, dropdownStates),
    saveDropdownStatesEnhanced: (dropdownStates) =>
      handleSaveDropdownStatesEnhanced(set, dropdownStates),
    restoreDropdownStates: () => handleRestoreDropdownStates(get()),
    restoreDropdownStatesEnhanced: () =>
      handleRestoreDropdownStatesEnhanced(get()),
    saveDropdownSelectedItems: (entryId, selectedItems) =>
      handleSaveDropdownSelectedItems(set, entryId, selectedItems),
    getDropdownSelectedItems: (entryId) =>
      handleGetDropdownSelectedItems(get(), entryId),
    resetDropdownStates: () => handleResetDropdownStates(set),
    setFromDoBoxPreview: (isFromDoBoxPreview) =>
      handleSetFromDoBoxPreview(set, isFromDoBoxPreview),
    getIsFromDoBoxPreview: () => handleGetIsFromDoBoxPreview(get()),
    resetState: () => set(INITIAL_DOBOX_DROPDOWN_STATE),
  };
};
